<form [formGroup]="form" class="d-flex w-100 flex-column mb-3">
  @if (!rule2 && !rule3) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix + 'accountNumber' | qaSlug">
      <label class="control-label"> Account Number </label>
      <input data-private id="accountNumber" pInputText class="txt-box form-control" type="text" formControlName="accountNumber" maxlength="50" />
    </div>
  }
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'defaultPaymentLeft' | qaSlug">
      <label class="control-label"> Payments Left </label>
      <input
        data-private
        id="defaultPaymentLeft"
        pInputText
        class="txt-box form-control"
        type="text"
        formControlName="defaultPaymentLeft"
        maxlength="7"
      />
    </div>
    @if (rule2 || rule3) {
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'held' | qaSlug">
        <label class="control-label"> Held </label>
        <p-select
          #liabilityType
          class="w-100"
          [options]="heldByTypes"
          formControlName="held"
          [optionLabel]="'value'"
          [optionValue]="'id'"
          appendTo="body"
        />
      </div>
    }
  </div>
  <div class="row">
    @if (rule5 || rule6) {
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'mortgageType' | qaSlug">
        <label class="control-label"> Mortgage Type </label>
        <p-select
          data-private
          class="w-100"
          [options]="mortgageTypes"
          formControlName="mortgageType"
          [optionLabel]="'value'"
          [optionValue]="'id'"
          appendTo="body"
        />
      </div>
    }
    @if (rule6) {
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'helocCreditLimit' | qaSlug">
        <label class="control-label"> HELOC Credit Limit </label>
        <p-inputNumber
          placeholder="$0.00"
          currency="USD"
          mode="currency"
          [max]="99999999999.99"
          locale="en-US"
          data-private
          id="helocCreditLimit"
          class="form-control"
          formControlName="helocCreditLimit"
          maxlength="50"
        />
      </div>
    }
  </div>
  @if (rule3 || rule7) {
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'otherDebtDescription' | qaSlug">
      <label class="control-label">
        Other Debt Description
        <span class="color-danger">*</span>
      </label>
      <input
        data-private
        id="otherDebtDescription"
        pInputText
        class="form-control"
        type="text"
        formControlName="otherDebtDescription"
        maxlength="50"
      />
    </div>
  }
  <div class="row">
    @if (!rule2 && !rule3) {
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'listedOnCreditReport' | qaSlug">
        <label class="control-label"> Listed On Credit Report </label>
        <div class="form-group">
          <div class="btn-group col-lg-12 col-md-12 col-sm-12 col-xs-12" role="group" aria-label="Basic radio toggle button group">
            <input
              type="radio"
              class="btn-check"
              name="listedOnCreditReport"
              id="listedOnCreditReport1"
              autocomplete="off"
              formControlName="listedOnCreditReport"
              value="true"
            />
            <label class="btn btn-outline-secondary" for="listedOnCreditReport1">Yes</label>
            <input
              type="radio"
              class="btn-check"
              name="listedOnCreditReport"
              id="listedOnCreditReport2"
              autocomplete="off"
              formControlName="listedOnCreditReport"
              value="false"
              checked
            />
            <label class="btn btn-outline-secondary" for="listedOnCreditReport2">No</label>
          </div>
        </div>
      </div>
    }
    @if (!rule2 && !rule3) {
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'resubordinated' | qaSlug">
        <label class="control-label"> Resubordinated </label>
        <div class="form-group">
          <div class="btn-group col-lg-12 col-md-12 col-sm-12 col-xs-12" role="group" aria-label="Basic radio toggle button group">
            <input
              type="radio"
              class="btn-check"
              formControlName="resubordinated"
              value="true"
              name="resubordinated"
              id="resubordinated1"
              autocomplete="off"
            />
            <label class="btn btn-outline-secondary" for="resubordinated1">Yes</label>
            <input
              type="radio"
              class="btn-check"
              formControlName="resubordinated"
              value="false"
              name="resubordinated"
              id="resubordinated2"
              autocomplete="off"
              checked
            />
            <label class="btn btn-outline-secondary" for="resubordinated2">No</label>
          </div>
        </div>
      </div>
    }
  </div>
  @if (!rule2 && !rule3) {
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'notCounted' | qaSlug">
      <label class="control-label"> Not Counted </label>
      <div class="form-group">
        <div class="btn-group col-lg-12 col-md-12 col-sm-12 col-xs-12" role="group" aria-label="Basic radio toggle button group">
          <input type="radio" class="btn-check" formControlName="notCounted" value="true" name="notCounted" id="notCounted1" autocomplete="off" />
          <label class="btn btn-outline-secondary" for="notCounted1">Yes</label>
          <input
            type="radio"
            class="btn-check"
            formControlName="notCounted"
            value="false"
            name="notCounted"
            id="notCounted2"
            autocomplete="off"
            checked
          />
          <label class="btn btn-outline-secondary" for="notCounted2">No</label>
        </div>
      </div>
    </div>
  }
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix + 'atrNotes' | qaSlug">
    <label class="form-label"> ATR Notes </label>
    @if (liabilityType === 1) {
      <textarea
        data-private
        id="atrNotes"
        pInputText
        class="form-control"
        type="text"
        formControlName="atrNotes"
        maxlength="500"
        rows="13"
      ></textarea>
    }
    @if (liabilityType === 2) {
      <textarea
        data-private
        id="qmatrNotes"
        pInputText
        class="form-control"
        type="text"
        formControlName="qmatrNotes"
        maxlength="500"
        rows="13"
      ></textarea>
    }
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix + 'otherNotes' | qaSlug">
    <label class="form-label"> Other Notes </label>
    <textarea data-private id="otherNotes" pInputText class="form-control" type="text" formControlName="otherNotes" rows="13"></textarea>
  </div>
  <div class="row">
    <div class="col-md-12 mt-3 d-flex justify-content-end">
      <button pButton type="button" severity="secondary" class="mx-1" (click)="onCancelClicked()">Cancel</button>
      <button pButton type="button" class="mx-1" (click)="updateInfo()" [disabled]="!form.valid">Done</button>
    </div>
  </div>
</form>
